import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È un prodotto fisico o digitale?',
  a: "GINNASTICA PRO™ è un prodotto 100% digitale in formato PDF ad alta qualità. Potrai scaricarlo immediatamente dopo l'acquisto e utilizzarlo da computer, tablet o smartphone."
}, {
  q: 'È adatto anche agli allenatori alle prime esperienze?',
  a: 'Assolutamente sì. Il sistema è stato progettato sia per chi inizia ad allenare sia per gli allenatori più esperti che desiderano risparmiare tempo, organizzare meglio gli allenamenti e lavorare con maggiore professionalità.'
}, {
  q: 'Posso utilizzarlo con ginnasti di livelli diversi?',
  a: 'Sì. Il sistema include materiale utilizzabile con ginnasti principianti, intermedi e avanzati, permettendoti di adattare facilmente ogni allenamento al livello del gruppo.'
}, {
  q: 'Posso personalizzare gli allenamenti?',
  a: 'Certamente. Tutti gli allenamenti, le progressioni e gli strumenti possono essere facilmente adattati al tuo metodo di insegnamento, alle attrezzature disponibili e agli obiettivi dei tuoi atleti.'
}, {
  q: 'Dopo quanto tempo vedrò i risultati?',
  a: 'La maggior parte degli allenatori inizia a risparmiare ore di preparazione già dalla prima settimana e si sente subito più organizzata e sicura durante gli allenamenti.'
}, {
  q: 'Il sistema copre tutti gli attrezzi (corpo libero, trave, parallele, volteggio)?',
  a: 'Sì. La Libreria di Esercizi e Progressioni è organizzata per corpo libero, trave, parallele e volteggio, con esercizi e progressioni tecniche pronti da utilizzare per ogni attrezzo e livello.'
}, {
  q: 'Quanti bonus sono inclusi e come li ricevo?',
  a: 'Con il tuo acquisto ricevi gratuitamente 5 bonus premium. Ti verranno consegnati istantaneamente via email insieme al sistema principale, pronti da scaricare e utilizzare subito.'
}, {
  q: 'Devo pagare un abbonamento mensile?',
  a: "No, si tratta di un pagamento unico di 27€. Ottieni l'accesso a vita all'intero sistema GINNASTICA PRO™ e a tutti i bonus, senza costi nascosti né abbonamenti."
}, {
  q: 'Posso stampare le schede e i planner?',
  a: 'Sì. Tutti i documenti (schede di valutazione, planner, checklist, registri) sono realizzati in alta risoluzione per essere facilmente stampati e utilizzati in formato cartaceo in palestra.'
}, {
  q: 'Come funziona la garanzia di 14 giorni?',
  a: "È molto semplice: hai 14 giorni per provare il sistema. Se non sarai completamente soddisfatto, ti basterà inviarci un'email e riceverai il rimborso del 100% del tuo acquisto, senza domande."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 sm:px-6 bg-white" data-id="element-33">
      <div className="text-center mb-6" data-id="element-34">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy mb-2 uppercase leading-tight" data-id="element-35">
          Domande Frequenti
        </h2>
      </div>

      <div className="flex flex-col gap-2" data-id="element-36">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-ivory border border-brand-border rounded-lg overflow-hidden shadow-sm" data-id="element-37">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3.5 text-left flex justify-between items-center hover:bg-brand-border/40 transition-colors gap-3" aria-expanded={openIndex === i} data-id="element-38">
              <span className="font-heading font-bold text-brand-navy text-sm sm:text-base leading-tight" data-id="element-39">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-violet transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-40" />
            </button>

            {openIndex === i && <div className="px-4 pb-4 pt-0 text-brand-text font-medium text-sm sm:text-base leading-relaxed" data-id="element-41">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}